import React from 'react';
import UserResources from '../../../User/userResources';

export default function UserResource() {
  return <UserResources />;
}
